import { LoginWithIdPOptions } from "../idp-auth";
import { NavigateOptions, RedirectLoginOptions } from "./context";

/**
 * Convert RedirectLoginOptions to LoginWithIdPOptions
 * @param opts
 * @constructor
 */
export function redirectLoginToIdPOptions(opts: RedirectLoginOptions): LoginWithIdPOptions {
  const { username, loginType, ...idpOptions } = opts;
  return {
    ...idpOptions,
    email: username,
  };
}

/**
 * Convert NavigateOptions to RedirectLoginOptions
 */
export function navigateToRedirectLoginOptions(
  loginType: string,
  opts: NavigateOptions
): RedirectLoginOptions {
  const { identifier, ...redirectOptions } = opts;
  return {
    ...redirectOptions,
    username: identifier,
    loginType,
  };
}
